import GalleryImagePickerController from "./gallery_image_picker_controller"

/**
 * Concrete implementation of GalleryImagePickerController for standard form fields.
 * Updates a hidden input with the selected image ID and optionally submits the form.
 */
export default class extends GalleryImagePickerController {
  static targets = [
    "imagePicker",
    "imageList",
    "imageUploadInput",
    "imageFirstButton",
    "imagePrevButton",
    "imageNextButton",
    "imageLastButton",
    "imagePaginationStatus",
    "paginationNav",
    "searchInput",
    "form",
    "input"
  ]

  connect() {
    super.connect()
  }

  /**
   * Clears the selected image and resets the input.
   */
  clearImage(event) {
    event.preventDefault()
    this.inputTarget.value = ""
    this.imagePickerTarget.classList.add("hidden")
    this.submitForm()
  }

  /**
   * Returns the current value of the associated input.
   */
  selectedImageValue() {
    return this.inputTarget.value
  }

  /**
   * Callback from base class when an image is clicked.
   */
  onImageSelect(image) {
    this.selectImage(image)
  }

  /**
   * Callback from base class after a successful upload.
   */
  afterUploadImage(image) {
    this.selectImage(image)
  }

  /**
   * Updates the input value with the image ID and hides the picker.
   */
  selectImage(image) {
    this.abortRequest()
    this.inputTarget.value = image.record_id || image.id
    this.imagePickerTarget.classList.add("hidden")
    this.submitForm()
  }

  /**
   * Triggers a form submission if a form target is defined.
   */
  submitForm() {
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }
}
